export default {
    searchInput: {
        height: 30,
        fontSize: 14,
        borderRadius: 15
    },
    searchIcon: {
        style: {
            marginLeft: 10,
            alignSelf: 'center'
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/SearchInput/styles.js